import { Injectable } from '@angular/core';
import { Auth, CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { CognitoUser } from 'amazon-cognito-identity-js';

@Injectable({
  providedIn: 'root',
})
export class AwsAmplifyService {
  federatedSignIn(provider: CognitoHostedUIIdentityProvider, customState?: string) {
    return Auth.federatedSignIn({ provider, customState });
  }

  async signIn(username: string, password: string): Promise<CognitoUser> {
    try {
      return (await this.currentAuthenticatedUser()) as CognitoUser;
    } catch {
      return (await Auth.signIn({ username, password })) as CognitoUser;
    }
  }

  currentAuthenticatedUser(): Promise<CognitoUser> {
    return Auth.currentAuthenticatedUser() as Promise<CognitoUser>;
  }

  currentSession() {
    return Auth.currentSession();
  }

  signOut() {
    return Auth.signOut({ global: true });
  }
}
